import { ScrollArea } from "@mantine/core";
import { modals } from "@mantine/modals";
import { ModalSettings, OpenContextModal } from "node_modules/@mantine/modals/lib/context";
import { ComponentProps } from "react";

import { AcceptTerms } from "@/components/_Modals/AcceptTermsModal";
import { CreateEdit } from "@/components/_Modals/create_edit";
import { Delete } from "@/components/_Modals/delete";
import { TermsModal } from "@/components/_Modals/TermsModal";
import { cn } from "@/utils";

export const MODALS = {
  terms: TermsModal,
  acceptTerms: AcceptTerms,
  deleteOrder: Delete.Order,
  deleteScheduling: Delete.Scheduling,
  deleteCompany: Delete.Company,
  deleteTruck: Delete.Truck,
  deleteDriver: Delete.Driver,
  createEditScheduling: CreateEdit.Scheduling,
  createEditTruckModel: CreateEdit.TruckModel,
  createEditTruckBrand: CreateEdit.TruckBrand
};

type Modals = typeof MODALS;
type ModalKey = keyof Modals;
type ModalByKey<T extends ModalKey> = Modals[T];
type ModalHandler<T extends ModalKey> = OpenContextModal<ComponentProps<ModalByKey<T>>["innerProps"]>["innerProps"];
type ModalOptions = Omit<OpenContextModal, "innerProps">;

const openTypedContextModal = <K extends ModalKey>(options: Omit<Parameters<typeof modals.openContextModal>[0], "modal"> & { modal: K }) =>
  modals.openContextModal({
    ...options,
    innerProps: options.innerProps ?? {},
  });

export const MODAL_HANDLER = {
  acceptTerms: (innerProps?: ModalHandler<"acceptTerms">, modalOptions?: ModalOptions) =>
    openTypedContextModal({
      modal: "acceptTerms",
      title: "Leia nossa politica de Privacidade e Termos de Uso",
      size: "xl",
      classNames: {
        title: cn("text-xl! font-bold!")
      },
      innerProps: innerProps!,
      ...modalOptions
    }),
  terms: (innerProps?: ModalHandler<"terms">, modalOptions?: ModalOptions) =>
    openTypedContextModal({
      modal: "terms",
      title: "Politica de Privacidade e Termos de Uso",
      size: "xxl",
      classNames: {
        title: cn("text-xl! font-bold!")
      },
      withCloseButton: false,
      innerProps: innerProps!,
      ...modalOptions
    }),
  delete: {
    order: (innerProps?: ModalHandler<"deleteOrder">, modalOptions?: ModalOptions) =>
      openTypedContextModal({
        modal: "deleteOrder",
        innerProps: innerProps!,
        withCloseButton: false,
        ...modalOptions
      }),
    scheduling: (innerProps?: ModalHandler<"deleteScheduling">, modalOptions?: ModalOptions) =>
      openTypedContextModal({
        modal: "deleteScheduling",
        innerProps: innerProps!,
        withCloseButton: false,
        ...modalOptions
      }),
    company: (innerProps?: ModalHandler<"deleteCompany">, modalOptions?: ModalOptions) =>
      openTypedContextModal({
        modal: "deleteCompany",
        innerProps: innerProps!,
        withCloseButton: false,
        ...modalOptions
      }),
    truck: (innerProps?: ModalHandler<"deleteTruck">, modalOptions?: ModalOptions) =>
      openTypedContextModal({
        modal: "deleteTruck",
        innerProps: innerProps!,
        withCloseButton: false,
        ...modalOptions
      }),
    driver: (innerProps?: ModalHandler<"deleteDriver">, modalOptions?: ModalOptions) =>
      openTypedContextModal({
        modal: "deleteDriver",
        innerProps: innerProps!,
        withCloseButton: false,
        ...modalOptions
      })
  },
  createEdit: {
    scheduling: (innerProps?: ModalHandler<"createEditScheduling">, modalOptions?: ModalOptions) =>
      openTypedContextModal({
        modal: "createEditScheduling",
        withCloseButton: false,
        size: "lg",
        innerProps: innerProps!,
        ...modalOptions
      }),
    truck: {
      model: (innerProps?: ModalHandler<"createEditTruckModel">, modalOptions?: ModalOptions) =>
        openTypedContextModal({
          modal: "createEditTruckModel",
          title: "Modelo de Caminhão",
          size: "md",
          innerProps: innerProps!,
          ...modalOptions
        }),
      brand: (innerProps?: ModalHandler<"createEditTruckBrand">, modalOptions?: ModalOptions) =>
        openTypedContextModal({
          modal: "createEditTruckBrand",
          title: "Marca de Caminhão",
          size: "md",
          innerProps: innerProps!,
          ...modalOptions
        })
    }
  }
};

export const MODAL_PROPS: ModalSettings = { scrollAreaComponent: ScrollArea.Autosize, centered: true };
